import { render, staticRenderFns } from "./Paye.view.vue?vue&type=template&id=3a92e3f1&"
import script from "./Paye.view.vue?vue&type=script&lang=js&"
export * from "./Paye.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports